import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

import LabelAndDisplay from "../../components/LabelAndDisplay";

function PriceHistoryRecordVoidConfirmDialog({
  open,
  summaryLines,
  isVoiding,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={isVoiding ? undefined : onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>Are you sure you want to delete?</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={1.5}>
          <Stack spacing={1.5}>
            {(summaryLines || []).map((line) => (
              <LabelAndDisplay key={line.label} label={line.label} value={line.value} />
            ))}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2, justifyContent: "flex-start" }}>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={onConfirm}
          disabled={isVoiding}
        >
          {isVoiding ? "Deleting…" : "Delete"}
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          onClick={onCancel}
          disabled={isVoiding}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PriceHistoryRecordVoidConfirmDialog;
